// src/context/AppConfigContext.jsx
import React, { createContext, useContext, useState } from 'react';

const AppConfigContext = createContext(undefined);

export const AppConfigProvider = ({ children, initialConfig }) => {
  const [appConfig, setAppConfig] = useState(initialConfig);

  const updateConfig = (updates) => {
    setAppConfig((prev) => ({ ...prev, ...updates }));
  };

  const value = {
    ...appConfig,
    updateConfig, // обязательно включить это явно!
  };

  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  );
};

export const useAppConfig = () => {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error('useAppConfig must be used within an AppConfigProvider');
  }
  return context;
};
